import { Injectable } from '@angular/core'
import { ToastService } from '@overtur-monorepo/keying-shared'
import moment from 'moment'
import { LoadingService } from './loading.service'
import { LoggingService } from './logging.service'

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private loggingService: LoggingService
  ) {}

  throw(error) {
    this.loggingService.log('Error Service:', error)
    this.loadingService.set({ isLoading: false, message: '' })

    let message = ''

    if (error.error && error.error.message) {
      message = error.error.message
    } else if (
      error &&
      error.error &&
      typeof error.error === 'string' &&
      !error.error.includes('<!DOCTYPE html') &&
      !error.error.includes('<!DOCTYPE HTML')
    ) {
      message = error.error
    } else if (error.status && error.statusText) {
      message = `${error.status}: ${error.statusText}`
    }

    // if (error.error && error.error.message) {
    //   message = error.error.message
    // } else if (error.status && error.statusText) {
    //   message = `${error.status}: ${error.statusText}`
    // }

    this.loggingService.log('MESSAGE:', message)

    this.toastService.showToast({
      title: 'Warning',
      subTitle: message,
      date: moment().format('MM/DD/YYYY'),
      type: 'error',
    })
  }

  confirm(success) {
    this.loggingService.log('Success Service:', success)
    this.loadingService.set({ isLoading: false, message: '' })

    let message = ''

    if (success) {
      message = success
    }

    this.toastService.showToast({
      title: 'Success',
      subTitle: message,
      date: moment().format('MM/DD/YYYY'),
      type: 'success',
    })
  }

  notify(title: string, message: string) {
    this.loadingService.set({ isLoading: false, message: '' })

    this.toastService.showToast({
      title,
      subTitle: message,
      type: 'info',
    })
  }

  showError(message: string): void {
    this.loadingService.set({ isLoading: false, message: '' })

    this.toastService.showToast({
      title: 'Warning',
      subTitle: message,
      date: moment().format('MM/DD/YYYY'),
      type: 'error',
    })
  }
}
